import { Component } from '@angular/core';

@Component({
  selector: 'app-horus-loader',
  standalone: true,
  imports: [],
  templateUrl: './horus-loader.component.html',
  styleUrl: './horus-loader.component.scss',
})
export class HorusLoaderComponent {}
